import { Component, OnInit, Input, ElementRef, ViewChild, Renderer, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectService } from '../../../api/services/project.services';
import { BomLine } from '../../../api/models/bom-line';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-import-data',
  templateUrl: './import-data.component.html',
  styleUrls: ['./import-data.component.scss']
})
export class ImportDataComponent implements OnInit {

  @Input() worksheetId: string;
  @Input() fileType: string;

  @ViewChild('downloadAnchor') anchor: ElementRef;
  @Output() saveEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  hasFile = false;
  fileId: string;
  errorCreatingByFile = false;
  errorMessage: string;

  constructor(
    public activeModal: NgbActiveModal,
    public projectService: ProjectService,
    private orderService: OrderService,
    private renderer: Renderer
  ) { }

  ngOnInit() {
    // Empty ngOnInit method
   }

  downloadTemplate() {
    this.renderer.invokeElementMethod(this.anchor.nativeElement, 'click', []);
  }

  onImportFileUploaded(id: string) {
    this.hasFile = true;
    this.fileId = id;
      this.projectService.createWorksheetDataLinesByImportCsvFile(this.fileId, this.worksheetId).subscribe((bomLines: BomLine[]) => {
        this.orderService.$newImportedBomLines.next(bomLines);
        this.saveEvent.emit(true);
      }, error => {
        this.errorCreatingByFile = true;
        this.errorMessage = error.error.message;
      });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-worksheet/import-data/import-data.component.ts